<template>
  <el-dialog :title="title" :visible.sync="visible" width="70%" :close-on-click-modal="false">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="公告标题:" prop="noticeTitle">
        <el-input type="text" :disabled="disabled"  :maxlength="30" v-model="data.noticeTitle" placeholder="请输入30字以内公告标题" clearable />
      </el-form-item>
      <el-form-item class="uEditor" label="公告详情:" prop="noticeContent">
        <UEditor v-model="data.content"></UEditor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm" v-if="!disabled">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import UEditor from '@/components/UEditor'
import { tenantAddNotice, editNotice } from "@/api/saas/package";


export default {
  name: "AddClueDialog",
  components: {
    UEditor,
  },
  data() {
    return {
      visible: false,
      disabled: false,
      title: '',
      rules: {
        noticeTitle: [
          {required: true, message: '请输入公告标题', trigger: 'change'}
        ],
        noticeContent:  [
          {required: true, message: '请输入公告内容', trigger: 'change'}
        ]
      },
      data: {
        noticeTitle: null,
        noticeContent: null,
        noticeType: 2 // （1通知 2公告）
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible (val) {
      if (!val) {
        // 重置formData
        this.resetFormData()
      }
    }
  },
  methods: {
    resetFormData () {
      this.resetForm("addForm");
      this.data.noticeTitle = null
      this.data.noticeContent = null
    },
    open (row, type) {
      this.visible = true
      this.resetFormData()
      if(type === 'see'){
        this.disabled = true
        this.data= row
        this.title = '查看公告'
      }else if(type === 'edit') {
        this.disabled = false
        this.data= row
        this.title = '编辑公告'
      }else{
        this.disabled = false
        this.title = '添加公告'
      }
    },
    handleFileChange (fileObjs) {
      this.data.fileObjs = fileObjs;
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {

          if(this.data.noticeId) {
            this.editNotice()
          }else {
            this.addNotice()
          }
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    editNotice() {
      const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
      editNotice({
        noticeId: this.data.noticeId,
        noticeTitle: this.data.noticeTitle,
        noticeContent: this.data.noticeContent,
        noticeType: 2
      }).then(response => {
          this.$emit('success')
          this.visible = false
          loading.close();
          this.msgSuccess("编辑公告成功");
        }).catch(error => {
          loading.close()
        })
    },
    addNotice() {
      const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
      tenantAddNotice(this.data).then(response => {
          this.$emit('success')
          this.visible = false
          loading.close();
          this.msgSuccess("新增公告成功");
        }).catch(error => {
          loading.close()
        })
    }
  }
};
</script>
